module.exports = __webpack_public_path__ + "static/media/memorial-heart-texas-logo.db298a14.svg";